import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PageAuthorize from '../../../../security/PageAuthorize';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import RouteTitle from '../../../../presentation/RouteTitle';
import {Dialog,DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import moment from 'moment';
import DateTime from 'react-datetime';

class DialerDetectionUserQueueDialog extends Component {
  constructor( props ) {
    super( props );
    this.voicefilepath = '/vfiles/'
    // States
    this.state = {
      show: props.show === undefined ? false : props.show,
      REACT_USER_ID: 0,
      DISPLAY_NAME:'',
      FROM_DATE: '',
      FROM_DATE_STATUS_MESSAGE: '',
      TO_DATE: '',
      TO_DATE_STATUS_MESSAGE: '',
      STATUS_MESSAGE: '',
      users: [],
      users_queue: [],
      loading_user_queue: false
    };

    // Dialog Events
    this.onClose = this.onClose.bind( this );

    // Bind Events
    this.onHandleException = this.onHandleException.bind( this );
    this.doLogOff = this.doLogOff.bind( this );
    this.getUsers = this.getUsers.bind( this );
    this.getUsersQueue = this.getUsersQueue.bind( this );
    this.onCancelMouseEnter = this.onCancelMouseEnter.bind( this );
    this.onCancelMouseLeave = this.onCancelMouseLeave.bind( this );
    this.onClearQueue = this.onClearQueue.bind( this );
    this.onClearMouseEnter = this.onClearMouseEnter.bind( this );
    this.onClearMouseLeave = this.onClearMouseLeave.bind( this );
    this.onAssignQueue = this.onAssignQueue.bind( this );
    this.onAssignMouseEnter = this.onAssignMouseEnter.bind( this );
    this.onAssignMouseLeave = this.onAssignMouseLeave.bind( this );
    this.onChangeUser = this.onChangeUser.bind( this );
    this.onChangeFromDate = this.onChangeFromDate.bind( this );
    this.onChangeToDate = this.onChangeToDate.bind( this );
  }

  componentDidMount( ) {
    let REACT_USER_ID = this.state.REACT_USER_ID;
    let DISPLAY_NAME = this.state.DISPLAY_NAME;
    const isVisible = this.state.show;
    if( isVisible === true ) {
      this.getUsers( ).then( ( result ) => {

        let users = result.map( ( user, index ) => {
          if( index === 0 ) {
            REACT_USER_ID = user.REACT_USER_ID;
            DISPLAY_NAME = user.DISPLAY_NAME;
          }
          return user;
        } );
    
        this.setState( {
          REACT_USER_ID : REACT_USER_ID,
          DISPLAY_NAME: DISPLAY_NAME,
          users: users
        }, this.getUsersQueue( REACT_USER_ID ) );
  
      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );
    }
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        show: nextProps.show === undefined ? false : nextProps.show
      }, () => {
        let REACT_USER_ID = this.state.REACT_USER_ID;
        let DISPLAY_NAME = this.state.DISPLAY_NAME;
        const isVisible = this.state.show;
        if( isVisible === true ) {
          this.getUsers( ).then( ( result ) => {
    
            let users = result.map( ( user, index ) => {
              if( index === 0 ) {
                REACT_USER_ID = user.REACT_USER_ID;
                DISPLAY_NAME = user.DISPLAY_NAME;
              }
              return user;
            } );
        
            this.setState( {
              REACT_USER_ID : REACT_USER_ID,
              DISPLAY_NAME: DISPLAY_NAME,
              users: users
            }, this.getUsersQueue( REACT_USER_ID ) );
      
          } ).catch( ( exception ) => {
            this.onHandleException( exception );
          } );
        }
      } );
    }
  }

  compareProps( props, nextProps ) {

    if( props.show !== nextProps.show ) {
      return true;
    } 

    return false;
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    let section = {title: 'Dialer Detection Queue'};
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( section.title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( section.title, e.statusText , 5000 );
    } else {
      if( e.statusText !== undefined ) {
        alerts.CRITICAL( section.title, e, false );
      } else {
        alerts.CRITICAL( section.title, e );
      }
    }
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ) {
      this.props.onClose( e );
    } else {
      this.setState({
        show: false
      } );
    }
  }

  getUsers = () => {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'dialerdetection/users/list' );
      if( api !== undefined ) {
        api.get( [] ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }  
    } );
  }

  getUsersQueue = ( REACT_USER_ID ) => {
    this.setState( {
      loading_user_queue: true
    }, () => {
      let api = new EtelAPI( 'dialerdetection/users/queue' );
      api.uri = '/dialerdetection/users/queue/' + REACT_USER_ID;
      api.get( [] ).then( ( results ) => { 
        let statusMessage = this.getRecordsStatus( results );
        this.setState( {
          users_queue: results,
          loading_user_queue: false,
          STATUS_MESSAGE: statusMessage
        } );
      } ).catch ( ( exception ) => { 
        this.onHandleException( exception );
      } );
    } );
  };

  getRecordsStatus( queue ) {
    if( queue.length === 0 ) {
      return "0 audio records in queue."
    } else if( queue.length === 1 ) {
      return "There is 1 audio record in queue."
    } else {
      return "There are " + queue.length + " audio records in queue."
    }
  }

  clearUserQueue = ( ) => {

    if( this.onValidate('clear' ) === false ) {
      return;
    }

    let { dispatch, bugsnag } = this.props;
    let alert = new Alerts( bugsnag, dispatch );
    let api = new EtelAPI( 'dialerdetection/users/queue/clear' );
    let parameters = {};
    parameters.REACT_USER_ID = this.state.REACT_USER_ID;
    api.update( parameters ).then ( ( results ) => {
      this.setState( {
        users_queue: [],
        FROM_DATE: '',
        TO_DATE: '',
      }, ( ) => {
        this.getUsersQueue( this.state.REACT_USER_ID );
      }, ( ) => {
        alert.SUCCESS( 'Dialer Detection Queues', 'Sucessfully cleared the queue for ' + this.state.DISPLAY_NAME + '.', 2500 );
      } );
    } ).catch ( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  assignUserQueue = ( ) => {

    if( this.onValidate( 'assign' ) === false ) {
      return;
    }

    let { bugsnag, dispatch } = this.props;
    let alert = new Alerts( bugsnag, dispatch );
    let api = new EtelAPI( 'dialerdetection/users/queue/assign' );
    let parameters = {};
    parameters.REACT_USER_ID = this.state.REACT_USER_ID;
    parameters.FROM_DATE = this.state.FROM_DATE;
    parameters.TO_DATE = this.state.TO_DATE;

    api.update( parameters ).then ( ( results ) => {
      this.setState( {
        users_queue: results
      }, () => {
        this.getUsersQueue( this.state.REACT_USER_ID );
      }, () => {
        alert.SUCCESS( 'Dialer Detection Queue', 'Succcessfully assigned queue for ' + this.state.DISPLAY_NAME + '.', 2500 );
      } );
    } ).catch ( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onValidate( key ) {
    if( key === 'clear' ) {
      return this.onClearQueueValidate();
    } else if( key === 'assign' ) {
      return this.onAssignQueueValidate();
    }
    return true;
  }

  onClearQueueValidate( ) {
    if( this.state.REACT_USER_ID === undefined || this.state.REACT_USER_ID === 0 ) {
      return false;
    }
    return true;
  }

  onAssignQueueValidate( ) {
    let { dispatch, bugsnag } = this.props;
    let alerts = new Alerts( bugsnag, dispatch );

    if( this.state.users_queue !== undefined ) {
      if( this.state.users_queue.length > 0 ) {
        alerts.WARNING( 'Dialer Detection Queues', 'User already has an existing queue. You must clear queue before assigning a new one.', 2500 );  
        return false;
      }
    }

    if( this.state.REACT_USER_ID === undefined || this.state.REACT_USER_ID === 0 ) {
      alerts.WARNING( 'Dialer Detection Queues', 'You must select a valid USER.', 5000 );
      return false;
    }

    if( this.state.FROM_DATE === undefined || this.state.FROM_DATE === '' ) {
      alerts.WARNING( 'Dialer Detection Queues', 'You must select FROM DATE to assign a new queue', 5000 );
      return false;
    }

    if( this.state.TO_DATE === undefined || this.state.TO_DATE === '' ) {
      alerts.WARNING( 'Dialer Detection Queues', 'You must select TO DATE to assign a new queue', 5000 );
      return false;
    }

    return true;
  }

  onCancelMouseEnter( e ) {
    this.setState({
        STATUS_MESSAGE: 'Close Dialer Detection Audio Queue Dialog.'
    } );
  }

  onCancelMouseLeave( e ) {
    let statusMessage = this.getRecordsStatus( this.state.users_queue );
    this.setState({
        STATUS_MESSAGE: statusMessage
    } );
  }

  onClearQueue( e ) {
    if( this.onValidate( 'clear' ) === true ) {
      this.clearUserQueue();
    }
  }

  onClearMouseEnter( e ) {
    this.setState({
      STATUS_MESSAGE: 'Clear Dialer Detection Audio Queue for ' + this.state.DISPLAY_NAME + '.'
    } );
  }

  onClearMouseLeave( e ) {
    let statusMessage = this.getRecordsStatus( this.state.users_queue );
    this.setState({
      STATUS_MESSAGE: statusMessage
    } );
  }

  onAssignQueue( e ) {
    if( this.onValidate( 'assign' ) === true ) {
      this.assignUserQueue();
    }
  }

  onAssignMouseEnter( e ) {
    this.setState({
      STATUS_MESSAGE: 'Assign Dialer Detection Audio Queue for ' + this.state.DISPLAY_NAME + '.'
    } );
  }

  onAssignMouseLeave( e ) {
    let statusMessage = this.getRecordsStatus( this.state.users_queue );
    this.setState({
      STATUS_MESSAGE: statusMessage
    } );
  }

  onChangeUser( e ) {
    const users = this.state.users;
    let DISPLAY_NAME = this.state.DISPLAY_NAME;
    if( users !== undefined ) {
      if( users.length > 0 ) {
        for( var index = 0; index < users.length; index++ ) {
          const user = users[ index ];
          if( parseInt( user.REACT_USER_ID, 10 ) === parseInt( e.target.value, 10 ) ) {
            DISPLAY_NAME = user.DISPLAY_NAME;
            break;
          }
        }
      }
    }
    this.setState( {  
      REACT_USER_ID: e.target.value,
      DISPLAY_NAME: DISPLAY_NAME,
    }, this.getUsersQueue( e.target.value ) );
  }

  onChangeFromDate( e ) {
    this.setState( {
      FROM_DATE: e._d
    } );
  }

  onChangeToDate( e ) {
    this.setState( {
      TO_DATE: e._d
    } );
  }

  onRenderUsers( ) {
    let options = [];
    if( this.state.users !== undefined ) {
      if( this.state.users.length > 0 ) {
        options = this.state.users.map( ( option, index ) => {
          let selected = false;
          if( this.state.REACT_USER_ID === 0 && index === 0 ) {
            selected = true;
          } else {
            if( option.REACT_USER_ID === this.state.REACT_USER_ID ) {
              selected = true;
            }  
          }
          return ( <option key={option.REACT_USER_ID} value={option.REACT_USER_ID} selected={selected}>{option.DISPLAY_NAME}</option> );
        } );
      }
    } 
    return options;
  }
 
  onRenderQueueStats() {
    if( this.state.users_queue.length > 0 ) {
      const records = this.state.users_queue.length;
      return (
        <div className="dialer-detection-users-grid-panel">
          {this.state.DISPLAY_NAME} has { records.toString() } { records > 1 ? 'records.' : 'record.'}
        </div>
      );
    } else {
      return (
        <span className="dialer-detection-users-no-rows">
          There were no rows available
        </span>
      );
    }
  }

  onRenderGrid() {
    const loading_user_queue = this.state.loading_user_queue;
    const users_queue = this.state.users_queue;
    let content = [];
    let headers = [];
    let rows = [];
    if( loading_user_queue === false ) {
      if( users_queue !== undefined ) {
        if( users_queue.length > 0 ) {
          headers.push(
            <span key="dialer-detection-audio-queue-grid-header-created" className="dialer-detection-audio-queue-grid-header-created">
              Created
            </span>
          )
          headers.push(
            <span key="dialer-detection-audio-queue-grid-header-song-name" className="dialer-detection-audio-queue-grid-header-song-name">
              Song Name
            </span>
          );
          headers.push(
            <span key="dialer-detection-audio-queue-grid-header-matches" className="dialer-detection-audio-queue-grid-header-matches">
              Matches
            </span>
          );          
          headers.push(
            <span key="dialer-detection-audio-queue-grid-header-hashes" className="dialer-detection-audio-queue-grid-header-hashes">
              Hashes
            </span>
          );          
          headers.push(
            <span key="dialer-detection-audio-queue-grid-header-confidence" className="dialer-detection-audio-queue-grid-header-confidence">
              Confidence
            </span>
          );
          headers.push(
            <span key="dialer-detection-audio-queue-grid-header-audio-file" className="dialer-detection-audio-queue-grid-header-audio-file">
              Audio File
            </span>
          );          
          headers.push(
            <span key="dialer-detection-audio-queue-grid-header-audio-sample" className="dialer-detection-audio-queue-grid-header-audio-sample">
              Audio Sample
            </span>
          );          
          content.push(
            <span key="dialer-detection-audio-queue-grid-header" className="dialer-detection-audio-queue-grid-header">
              {headers}
            </span>
          );

          for( let index = 0; index < users_queue.length; index++ ) {
            let cells = [];
            const queueItem = users_queue[ index ];
            const created = moment( queueItem.Insert_DateTime );
            cells.push(
              <span key="dialer-detection-audio-queue-grid-row-cell-created" className="dialer-detection-audio-queue-grid-row-cell-created">
                {created.format('YYYY-MM-DD HH:mm:ss')}
              </span>
            )
            cells.push(
              <span key="dialer-detection-audio-queue-grid-row-cell-song-name" className="dialer-detection-audio-queue-grid-row-cell-song-name">
                {queueItem.Song_Name}
              </span>
            );
            cells.push(
              <span key="dialer-detection-audio-queue-grid-row-cell-matches" className="dialer-detection-audio-queue-grid-row-cell-matches">
                {queueItem.Tot_Matches}
              </span>
            );          
            cells.push(
              <span key="dialer-detection-audio-queue-grid-row-cell-hashes" className="dialer-detection-audio-queue-grid-row-cell-hashes">
                {queueItem.Tot_Hashes}
              </span>
            );          
            cells.push(
              <span key="dialer-detection-audio-queue-grid-row-cell-confidence" className="dialer-detection-audio-queue-grid-row-cell-confidence">
                {queueItem.Confidence}
              </span>
            );
            cells.push(
              <span key="dialer-detection-audio-queue-grid-row-cell-audio-file" className="dialer-detection-audio-queue-grid-row-cell-audio-file">
                {queueItem.m_uuid + '.mp3'}
              </span>
            );          
            cells.push(
              <span key="dialer-detection-audio-queue-grid-row-cell-audio-sample" className="dialer-detection-audio-queue-grid-row-cell-audio-sample">
                <audio controls src={this.voicefilepath + queueItem.m_uuid + '.mp3'}>
                  Your browser does not support the <code>audio</code> element.
                </audio>
              </span>
            );          

            if( index % 2 === 0 ) {
              rows.push(
                <span key={'dialer-detection-audio-queue-grid-row-' + index.toString()} className="dialer-detection-audio-queue-grid-row-alt">
                  {cells}
                </span>
              );         
            } else {
              rows.push(
                <span key={'dialer-detection-audio-queue-grid-row-' + index.toString()} className="dialer-detection-audio-queue-grid-row">
                  {cells}
                </span>
              );         
            }
          }
          content.push(
            <span key="dialer-detection-audio-queue-grid-rows" className="dialer-detection-audio-queue-grid-rows">
              {rows}
            </span>
          );
        } else {
          content.push(
            <span key="dialer-detection-audio-queue-grid-no-rows" className="dialer-detection-audio-queue-grid-no-rows">
              No audio files are in the queue for this user.
            </span>
          );
        }
      } else {
        content.push(
          <span key="dialer-detection-audio-queue-grid-no-rows" className="dialer-detection-audio-queue-grid-no-rows">
            No audio files are in the queue for this user.
          </span>
        );
      }
    } else {
      content.push(
        <span key="dialer-detection-audio-queue-grid-please-wait" className="dialer-detection-audio-queue-grid-please-wait">
          Please wait retreiving audio files for this user.
        </span>
      );
    }
    return content;
  }

  onRenderHeader( ) {
    return <DialogHeader caption={'Dialer Detection Audio Queue'} closeButton onClose={this.onClose} />
  }

  onRenderBody( ) {
    return (
      <DialogBody>
        <span className="dialer-detection-audio-queue-dialog">
          <span className="dialer-detection-audio-queue-select-user">
            <span className="dialer-detection-audio-queue-select-user-label">
              <span className="dialer-detection-users-label">
                Select User:
              </span>
            </span>
            <span className="dialer-detection-audio-queue-select-user-dropdown">
              <select className="dialer-detection-users-dropdown" onChange={this.onChangeUser}>
                {this.onRenderUsers()}
              </select>
            </span>
            <span className="dialer-detection-audio-queue-select-user-empty-cell">
            </span>            
          </span>
          <span className="dialer-detection-audio-queue-from-date">
            <span className="dialer-detection-audio-queue-from-date-label">
              <span className="dialer-detection-users-label">
                From:
              </span>
            </span>
            <span className="dialer-detection-audio-queue-from-date-dropdown">
              <DateTime value={this.state.FROM_DATE} onChange={this.onChangeFromDate} />
            </span>
            <span className="dialer-detection-audio-queue-from-date-status">
              {this.state.FROM_DATE_STATUS_MESSAGE}
            </span>                                  
          </span>
          <span className="dialer-detection-audio-queue-to-date">
            <span className="dialer-detection-audio-queue-to-date-label">
            <span className="dialer-detection-users-label">
                To:
              </span>
            </span>
            <span className="dialer-detection-audio-queue-to-date-dropdown">
              <DateTime value={this.state.TO_DATE} onChange={this.onChangeToDate} />
            </span>
            <span className="dialer-detection-audio-queue-to-date-status">
              {this.state.TO_DATE_STATUS_MESSAGE}
            </span>                                  
          </span>
          <span className="dialer-detection-audio-queue-grid">
            {this.onRenderGrid()}
          </span>
        </span>
      </DialogBody>      
    );
  }

  onRenderFooter( ) {
    return (
      <DialogFooter>
        <span className="dialer-detection-user-queue-footer">
          <span className="dialer-detection-user-queue-footer-status">
            {this.state.STATUS_MESSAGE}
          </span>
          <span className="dialer-detection-user-queue-footer-cancel">
            <button 
              className="dialer-detection-cancel-button" 
              onClick={this.onClose} 
              onMouseEnter={this.onCancelMouseEnter}
              onMouseLeave={this.onCancelMouseLeave}>
                Cancel
            </button>
          </span>
          <span className="dialer-detection-user-queue-footer-clear">
            <button 
              className="dialer-detection-users-button" 
              onClick={this.onClearQueue} 
              onMouseEnter={this.onClearMouseEnter}
              onMouseLeave={this.onClearMouseLeave}>
                Clear
            </button> 
          </span>
          <span className="dialer-detection-user-queue-footer-assign">
            <button className="dialer-detection-users-button" 
              onClick={this.onAssignQueue} 
              onMouseEnter={this.onAssignMouseEnter}
              onMouseLeave={this.onAssignMouseLeave}>
              Assign
            </button>
          </span>
        </span>
      </DialogFooter>
    );
  }

  render() {
    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management', 'Interns']}>
        <RouteTitle title={'Dialer Detection - Manage User Queue'} />
        <Dialog show={this.state.show} width={90} height={90} onClose={this.onClose} >
          {this.onRenderHeader()}
          {this.onRenderBody()}
          {this.onRenderFooter()}
        </Dialog>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( DialerDetectionUserQueueDialog ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/dialerdetection/components/DialerDetectionUserQueueDialog.js